import { render, staticRenderFns } from "./PurgeDetails.vue?vue&type=template&id=da3997ee&scoped=true&"
import script from "./PurgeDetails.vue?vue&type=script&lang=js&"
export * from "./PurgeDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurgeDetails.vue?vue&type=style&index=0&id=da3997ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3997ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
